module.exports = __webpack_public_path__ + "img/ll.64f5d099.png";